// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nsection[data-v-1f3a6498] {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, 1fr);\n\tgrid-gap: 16px;\n}\nlabel[data-v-1f3a6498] {\n\tfont-size: 0.8rem;\n}\n", ""]);
// Exports
module.exports = exports;
